const data = {
  home: {
    create: "create",
    list: "Creation List",
    myContent: "My content",
    message: "MESSAGE",
    notice: "NOTICE",
    creation: "My creation",
    Setting: "setting",
    logout: "logout",
    language: "language",
    content1: "Please select the creation category you want to create",
    content2: "Create a game",
    content3: "What is a reality game",
    address: "6th Floor, Jinsui Building, Gaoming District, Foshan City",
    download: "App download",
    info1: "About us",
    info2: "Live-action games",
    info3: "Smart Guide",
    info4: "Corporate Cooperation",
    info5: "Create a tour/game",
  },
  edit: {
    backContent: "Return to the list",
    menu: {
      coverSetting: "Cover design",
      contentEdit: "Content editing",
      more: "more",
      plotEditing: "Plot editing",
      gameEvent: "Game events",
      roleAndScene: "Characters and scenes",
      bifurcated: "Bifurcated routes",
      gameDesign: "Game class design",
      collection: "Item collection",
      published: "Building the game",
      storyBackground: "Story Background",
      pointManagement: "Points Management",
      questionnaire: "Questionnaire",
    },
    cover: {
      title: "Cover Introduction",
      save: "Save",
      next: "Next",
      gameTitle: "Game Title",
      gameCategory: "Game Category",
      gameLanguage: "Game Language",
      difficulty: "Difficulty",
      playTime: "Play Time（min）",
      gameCover: "Game Cover Image",
      gameDescription: "Game Description",
      titleApp: "App Mockup - Create Cover",
      app1: "About",
      app2: "Game Difficulty",
      app3: "Game Time",
      app4: "Map Navigation",
      app5: "Introduction",
      opening_hours: "Opening Hours",
      experience_time: "Ticket reservations",
      begin: "Start Point",
      end: "End Point",
      walking_distance: "Walking Distance",
      estimated_time: "Estimated Time",
      Facilities_along_way: "Facilities Along the Way",
      multiplayer_game: "Multiplayer Game",
      player_age: "Player Age",
      transportation: "Transportation",
      area: "Region",
      address: "Address",
      introduction: "Introduction",
      tag: "Tag",
      slideshow: "Slideshow: Drag to Sort",
      research_characteristics: "Research Characteristics",
    },
  },
  login: {
    title: "Login",
    username: "Username",
    usernamePlaceholder: "Username must be 6 to 9 non-special characters",
    password: "Password",
    passwordPlaceholder: "Password must be 6 to 9 non-special characters",
    submit: "Submit",
    switch: "Back to login",
  },
  register: {
    title: "Register",
    switch: "Go to Register",
    submit: "Submit",
  },

  settings: {
    title: "Settings",
    username: "Username",
    password: "Password",
    language: "Language",
    save: "Save",
    avatar: "avatar",
    usernamePlaceholder: "Enter your username",
    passwordPlaceholder: "Enter your password",
    confirmPassword: "confirm",
    newPassword: "New password",
    clearImg: "Clear Picture",
    back: "back",
  },
  List: {
    button1: "Return",
    button2: "Home",
    button3: "Edit",
    button4: "Delete",
    tip: "Update Time",
    deleteInfo: "Do you want to delete the game?",
    channel: "Cancel",
    confirm: "Confirm",
    creationList: "Creation List",
    trashCan: "Trash Can",
  },
  Content: {
    tip1: "Drag to sort",
    tip2: "The game order is the card order",
    addLevel: "Add Level",
    deleteInfo: "Do you want to delete the level?",
    channel: "Cancel",
    confirm: "Confirm",
    gaud: "Gaode Map",
    customize: "Custom Map",
    contentEdit: "Content Edit",
    save: "Save",
  },
  Detail: {
    title: "Title",
    LevelTitle: "Level Title",
    LevelContent: "Level Puzzle Content",
    difficulty: "Game Difficulty",
    storeTitle: "Story Title",
    storeContent: "Story Content",
    clues: "Game Clues (upload up to 3 images)",
    answer: "Puzzle Answer",
    tipTitle: "Hint Title",
    tipContent: "Hint Content",
    back: "Back",
    save: "Save",
  },
};

export default data;
